<template>
  <button
    class="baner__button custom-btn custom-btn--green mt-5 mx-auto d-flex justify-self-center"
    @click="backToResults()">
      back
  </button>
</template>

<script>
export default {
  methods: {
    backToResults() {
      window.history.back();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Helpers/GoBackButton.vue